import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import TeletelAuditTrailIndex from './Index.vue';

/**
 * Teletel audit trail. Independent of the Chatwoot Enterprise "Audit Logs" page:
 * different path, different route name, different component, different API.
 *
 * Administrators only. The server enforces the same rule, so hiding the route is
 * a convenience, never the control.
 */
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/teletel-audit-trail'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'teletel_audit_trail', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'teletel_audit_trail',
          meta: {
            permissions: ['administrator'],
          },
          component: TeletelAuditTrailIndex,
        },
      ],
    },
  ],
};
